import React, { createContext, useContext, useEffect, useState } from "react";

export const translations = {
  sk: {
    nav: { home: "Domov", services: "Služby", gallery: "Galéria", reviews: "Recenzie", about: "O nás", contact: "Kontakt", book: "Objednať servis", call: "Zavolať" },
    hero: {
      badge: "Servis • Údržba • Návrh • Realizácia • Webové stránky",
      titleA: "Servis elektroniky, elektroinštalácie a ",
      titleB: "technické riešenia na mieru",
      subtitle: "Servis elektroniky, elektroinštalácie, fotovoltika, kamerové systémy, tvorba web stránok a zákazkové technické riešenia na jednom mieste.",
      book: "Odoslať požiadavku", whatsapp: "WhatsApp", call: "Zavolať",
      scrollHint: "Rolujte a sledujte, ako sa z loga rozvinie náš technologický ekosystém",
    },
    mosaic: { phone: "Smartfón", laptop: "Notebook", board: "Rozvádzač", solar: "Fotovoltika", camera: "Kamera", plc: "PLC / riadenie", hub: "Riešenia na mieru" },
    teardown: { glass: "Predné sklo", display: "Displej", board: "Základná doska", battery: "Batéria", chassis: "Zadný kryt" },
    ecosystem: {
      board: { t: "Rozvádzače", s: "a elektroinštalácie" },
      pcb: { t: "Elektronika", s: "a riadiace systémy" },
      cables: { t: "Káble", s: "a elektroinštalácie" },
      battery: { t: "Batérie", s: "a úložiská energie" },
      solar: { t: "Fotovoltika", s: "a solárne systémy" },
      breaker: { t: "Ističe, svorkovnice", s: "a elektro komponenty" },
    },
    services: {
      eyebrow: "Naše služby",
      title: "Komplexný servis a technické riešenia",
      subtitle: "Od opráv elektroniky a notebookov až po elektroinštalácie, fotovoltiku a kamerové systémy — pod jednou strechou.",
      notFound: "Nenašli ste svoju službu?",
      cta: "Napíšte nám požiadavku",
      items: [
        { title: "Servis elektroniky", desc: "Diagnostika a oprava spotrebnej aj profesionálnej elektroniky." },
        { title: "Opravy notebookov a počítačov", desc: "Hardvér, chladenie, čistenie a obnova dát." },
        { title: "Domáca a priemyselná elektronika", desc: "Servis riadiacich jednotiek, spotrebičov a priemyselných zariadení." },
        { title: "Elektroinštalácie", desc: "Návrh, montáž a opravy elektroinštalácií a rozvádzačov." },
        { title: "Fotovoltika", desc: "Návrh a technická podpora fotovoltaických systémov." },
        { title: "Kamerové systémy", desc: "Inštalácia a servis kamerových a bezpečnostných systémov." },
        { title: "Špeciálne elektro riešenia na mieru", desc: "Zákazkové technické riešenia podľa potrieb zákazníka." },
        { title: "Poradenstvo v elektrotechnike", desc: "Odborné poradenstvo pri návrhu a riešení zapojení." },
        { title: "Tvorba webových stránok", desc: "Návrh, tvorba a správa moderných webových stránok a online prezentácií." },
      ],
    },
    gallery: {
      eyebrow: "Galéria", title: "Ukážky našej práce", subtitle: "Kliknutím na náhľad otvoríte obrázok v plnej veľkosti.", viewFull: "Zobraziť celú galériu",
      alts: [
        "Detail dosky plošných spojov", "Spájkovanie pri oprave", "Oprava notebooku", "Montáž fotovoltiky na streche",
        "Elektroinštalácia a rozvádzač", "Inštalácia kamerového systému", "Doska plošných spojov", "Priemyselná elektronika",
        "Fotovoltaické panely na dome", "Meranie elektrického rozvádzača", "Bezpečnostné kamery", "Mikroskopická oprava elektroniky",
        "Zapojenie rozvodnej skrine", "Fotovoltika na rodinnom dome",
      ],
    },
    galleryPage: { eyebrow: "Galéria", title: "Galéria", subtitle: "Ukážky realizácií z rôznych oblastí — servis elektroniky, elektroinštalácie, fotovoltika a kamerové systémy.", back: "Späť na web" },
    reviews: {
      eyebrow: "Google recenzie", title: "Čo hovoria naši zákazníci", ratingSuffix: "recenzií na Google",
      googleBtn: "Zobraziť Google recenzie", writeBtn: "Napísať recenziu na Google",
    },
    about: {
      eyebrow: "O nás", title: "Technická precíznosť, ktorej môžete dôverovať",
      p1: "Sedlo Services je poskytovateľ komplexných technických riešení pôsobiaci v Žiline a okolí. Venujeme sa servisu elektroniky, opravám notebookov a počítačov, domácej a priemyselnej elektronike, elektroinštaláciám, fotovoltike, kamerovým systémom aj zákazkovým elektro riešeniam na mieru.",
      p2: "Naším cieľom je poskytnúť spoľahlivé riešenia pre domácnosti aj firmy. Každú požiadavku posudzujeme individuálne a dbáme na kvalitu odvedenej práce.",
      p3: "Rovnakú precíznosť, akú venujeme servisu elektroniky, elektroinštaláciám a technickým riešeniam, venujeme aj tvorbe moderných webových stránok pre živnostníkov, firmy a lokálne podniky.",
      features: [
        { title: "Individuálny prístup", desc: "Ku každej zákazke pristupujeme individuálne." },
        { title: "Transparentná komunikácia", desc: "Jasne a férovo počas celého procesu." },
        { title: "Kvalitne odvedená práca", desc: "Dôraz na kvalitu a spoľahlivosť." },
        { title: "Rýchla reakcia podľa možností", desc: "Ozveme sa čo najskôr, ako to je možné." },
      ],
    },
    booking: {
      eyebrow: "Objednávka servisu", title: "Odošlite požiadavku",
      subtitle: "Vyplňte formulár a my sa vám ozveme. Každá požiadavka dostane jedinečné číslo.",
      name: "Meno a priezvisko", namePh: "Ján Novák", phone: "Telefón", phonePh: "+421 900 000 000",
      email: "Email", emailPh: "jan@email.sk", serviceType: "Typ služby", serviceTypePh: "Vyberte službu",
      device: "Zariadenie / typ problému", devicePh: "napr. iPhone 13 — nefunkčný displej",
      description: "Popis problému", descriptionPh: "Popíšte prosím čo najpodrobnejšie…",
      files: "Fotografie / súbory (nepovinné)", filesPh: "Nahrajte fotografie zariadenia (max 4)",
      preferred: "Preferovaný spôsob kontaktu", optPhone: "Telefón", optEmail: "Email", optWhatsapp: "WhatsApp",
      gdprPre: "Súhlasím so spracovaním osobných údajov za účelom vybavenia mojej požiadavky a oboznámil som sa so ",
      gdprLink: "zásadami ochrany osobných údajov",
      submit: "Odoslať požiadavku", submitting: "Odosielam…",
      successTitle: "Požiadavka bola prijatá!", successNumberLabel: "Vaše číslo požiadavky je:",
      successNote: "Uschovajte si toto číslo. Budeme vás kontaktovať zvoleným spôsobom.", newRequest: "Odoslať ďalšiu požiadavku",
      errRequired: "Vyplňte prosím všetky povinné polia.", errGdpr: "Potvrďte prosím súhlas so spracovaním osobných údajov.",
      toastSentA: "Požiadavka ", toastSentB: " bola odoslaná.", toastFail: "Odoslanie zlyhalo. Skúste to znova.", fileTooBig: "Každý súbor môže mať maximálne 5 MB.",
    },
    contact: {
      eyebrow: "Kontakt", title: "Nájdite nás v Žiline", subtitle: "Zavolajte, napíšte alebo nás navštívte osobne.",
      phone: "Telefón", email: "Email", whatsapp: "WhatsApp", address: "Adresa", hours: "Otváracie hodiny",
      hoursNote: "Individuálne podľa dohody a povahy zákazky.", directions: "Ako sa k nám dostať", follow: "Sledujte nás", mapTitle: "Mapa — Sedlo Services Žilina",
    },
    footer: {
      tagline: "Servis elektroniky, opravy zariadení a elektrotechnické riešenia pre domácnosti aj firmy v Žiline a okolí.",
      navTitle: "Navigácia", contactTitle: "Kontakt", directions: "Ako sa k nám dostať",
      rights: "Všetky práva vyhradené.", privacy: "Ochrana osobných údajov", authorPre: "Web vytvoril ",
      links: [["Služby", "#services"], ["Galéria", "#gallery"], ["Recenzie", "#reviews"], ["O nás", "#about"], ["Kontakt", "#contact"], ["Objednať servis", "#booking"]],
    },
    chatbot: {
      title: "Asistent Sedlo Services", subtitle: "Vytvorí za vás požiadavku",
      welcome: "Dobrý deň, popíšte nám prosím váš problém alebo požiadavku.",
      placeholder: "Napíšte správu…", needConsent: "Najprv potvrďte súhlas GDPR",
      gdprPre: "Súhlasím so spracovaním osobných údajov za účelom vybavenia mojej požiadavky a oboznámil som sa so ",
      gdprLink: "zásadami ochrany osobných údajov",
      unavailable: "Prepáčte, momentálne nie som dostupný. Vyplňte prosím formulár alebo nám zavolajte.",
    },
    cookie: { text: "Používame súbory cookie na zlepšenie funkčnosti stránky. Viac v ", link: "zásadách ochrany osobných údajov", accept: "Súhlasím", decline: "Odmietnuť" },
    privacy: {
      back: "Späť na web", eyebrow: "GDPR", title: "Zásady ochrany osobných údajov",
      intro: "Ochrana vašich osobných údajov je pre Sedlo Services dôležitá. V tomto dokumente vysvetľujeme, aké údaje spracúvame, na aký účel a ako dlho ich uchovávame.",
      sections: [
        { h: "1. Prevádzkovateľ", p: "Prevádzkovateľom osobných údajov je Sedlo Services, {addr}. Kontakt vo veciach ochrany osobných údajov: {email}, telefón {phone}." },
        { h: "2. Účel spracovania", p: "Sedlo Services spracúva osobné údaje zákazníkov výlučne za účelom vybavenia servisných požiadaviek, komunikácie so zákazníkom a realizácie objednaných služieb." },
        { h: "3. Rozsah spracúvaných údajov", p: "Spracúvané údaje môžu zahŕňať meno, telefónne číslo, e-mailovú adresu, popis problému a prípadné fotografie zaslané zákazníkom." },
        { h: "4. Poskytovanie údajov tretím stranám", p: "Osobné údaje nie sú poskytované tretím stranám, s výnimkou prípadov vyžadovaných právnymi predpismi alebo nevyhnutných na splnenie požadovanej služby." },
        { h: "5. Doba uchovávania", p: "Údaje sú uchovávané len po dobu potrebnú na vybavenie požiadavky, maximálne však 24 mesiacov, pokiaľ právne predpisy neustanovujú inú dobu uchovávania." },
        { h: "6. Práva dotknutej osoby", p: "Zákazník má právo na prístup k svojim osobným údajom, ich opravu, vymazanie, obmedzenie spracovania, ako aj právo namietať spracúvanie a právo na prenosnosť údajov. Svoje práva môže uplatniť na e-mailovej adrese {email}. Zákazník má taktiež právo podať sťažnosť dozornému orgánu (Úrad na ochranu osobných údajov Slovenskej republiky)." },
        { h: "7. Súhlas a súbory cookie", p: "Odoslanie požiadavky prostredníctvom formulára alebo chatbota je podmienené udelením súhlasu so spracovaním osobných údajov. Webová stránka používa nevyhnutné súbory cookie pre správne fungovanie; ďalšie súbory cookie používame len na základe vášho súhlasu." },
        { h: "8. Kontakt", p: "V prípade akýchkoľvek otázok týkajúcich sa ochrany osobných údajov nás kontaktujte na {email}." },
      ],
    },
    meta: {
      title: "Sedlo Services — Servis elektroniky Žilina | Rýchle riešenia. Spoľahlivý servis.",
      privacyTitle: "Ochrana osobných údajov — Sedlo Services",
      galleryTitle: "Galéria — Sedlo Services",
    },
  },

  en: {
    nav: { home: "Home", services: "Services", gallery: "Gallery", reviews: "Reviews", about: "About", contact: "Contact", book: "Book service", call: "Call" },
    hero: {
      badge: "Service • Maintenance • Design & Installation • Web Development",
      titleA: "Electronics repair, electrical installations and ",
      titleB: "custom technical solutions",
      subtitle: "Electronics repair, electrical installations, photovoltaics, camera systems, website development and bespoke technical solutions — all in one place.",
      book: "Send a request", whatsapp: "WhatsApp", call: "Call",
      scrollHint: "Scroll to watch our technical ecosystem unfold from the logo",
    },
    mosaic: { phone: "Smartphone", laptop: "Laptop", board: "Switchboard", solar: "Photovoltaics", camera: "Camera", plc: "PLC / control", hub: "Custom solutions" },
    teardown: { glass: "Front glass", display: "Display", board: "Logic board", battery: "Battery", chassis: "Rear housing" },
    ecosystem: {
      board: { t: "Switchboards", s: "and wiring" },
      pcb: { t: "Electronics", s: "and control systems" },
      cables: { t: "Cables", s: "and wiring" },
      battery: { t: "Batteries", s: "and energy storage" },
      solar: { t: "Photovoltaics", s: "and solar systems" },
      breaker: { t: "Breakers & terminals", s: "and electrical parts" },
    },
    services: {
      eyebrow: "Our services",
      title: "Complete service and technical solutions",
      subtitle: "From electronics and laptop repairs to electrical installations, photovoltaics and camera systems — all under one roof.",
      notFound: "Didn't find your service?",
      cta: "Send us a request",
      items: [
        { title: "Electronics repair", desc: "Diagnostics and repair of consumer and professional electronics." },
        { title: "Laptop & computer repairs", desc: "Hardware, cooling, cleaning and data recovery." },
        { title: "Home & industrial electronics", desc: "Servicing of control units, appliances and industrial equipment." },
        { title: "Electrical installations", desc: "Design, installation and repair of wiring and distribution boards." },
        { title: "Photovoltaics", desc: "Design and technical support for photovoltaic systems." },
        { title: "Camera systems", desc: "Installation and servicing of camera and security systems." },
        { title: "Custom electrical solutions", desc: "Bespoke technical solutions tailored to your needs." },
        { title: "Electrical engineering consulting", desc: "Expert advice on design and wiring solutions." },
        { title: "Website development", desc: "Design, development and management of modern websites and online presentations." },
      ],
    },
    gallery: {
      eyebrow: "Gallery", title: "Examples of our work", subtitle: "Click a thumbnail to open the image in full size.", viewFull: "View full gallery",
      alts: [
        "Close-up of a circuit board", "Soldering during a repair", "Laptop repair", "Rooftop photovoltaic installation",
        "Electrical installation and switchboard", "Camera system installation", "Printed circuit board", "Industrial electronics",
        "Photovoltaic panels on a house", "Measuring an electrical switchboard", "Security cameras", "Microscopic electronics repair",
        "Wiring a distribution box", "Photovoltaics on a family house",
      ],
    },
    galleryPage: { eyebrow: "Gallery", title: "Gallery", subtitle: "Examples of completed projects across various fields — electronics repair, electrical installations, photovoltaics and camera systems.", back: "Back to site" },
    reviews: {
      eyebrow: "Google reviews", title: "What our customers say", ratingSuffix: "reviews on Google",
      googleBtn: "View Google reviews", writeBtn: "Write a review on Google",
    },
    about: {
      eyebrow: "About us", title: "Technical precision you can trust",
      p1: "Sedlo Services is a provider of complete technical solutions based in Žilina and the surrounding area. We specialise in electronics repair, laptop and computer repairs, home and industrial electronics, electrical installations, photovoltaics, camera systems and custom electrical solutions.",
      p2: "Our goal is to deliver reliable solutions for households and businesses alike. We assess every request individually and take pride in the quality of our work.",
      p3: "The same precision we bring to electronics repair, electrical installations and technical solutions, we also bring to building modern websites for sole traders, companies and local businesses.",
      features: [
        { title: "Personal approach", desc: "We treat every project individually." },
        { title: "Transparent communication", desc: "Clear and fair throughout the entire process." },
        { title: "Quality workmanship", desc: "A focus on quality and reliability." },
        { title: "Prompt response when possible", desc: "We get back to you as soon as we can." },
      ],
    },
    booking: {
      eyebrow: "Book a service", title: "Send a request",
      subtitle: "Fill in the form and we'll get back to you. Every request receives a unique number.",
      name: "Full name", namePh: "John Smith", phone: "Phone", phonePh: "+421 900 000 000",
      email: "Email", emailPh: "john@email.com", serviceType: "Service type", serviceTypePh: "Select a service",
      device: "Device / type of problem", devicePh: "e.g. iPhone 13 — broken display",
      description: "Problem description", descriptionPh: "Please describe it in as much detail as possible…",
      files: "Photos / files (optional)", filesPh: "Upload photos of the device (max 4)",
      preferred: "Preferred contact method", optPhone: "Phone", optEmail: "Email", optWhatsapp: "WhatsApp",
      gdprPre: "I consent to the processing of my personal data for the purpose of handling my request and I have read the ",
      gdprLink: "privacy policy",
      submit: "Send request", submitting: "Sending…",
      successTitle: "Request received!", successNumberLabel: "Your request number is:",
      successNote: "Please keep this number. We will contact you via your chosen method.", newRequest: "Send another request",
      errRequired: "Please fill in all required fields.", errGdpr: "Please confirm your consent to the processing of personal data.",
      toastSentA: "Request ", toastSentB: " has been sent.", toastFail: "Submission failed. Please try again.", fileTooBig: "Each file can be up to 5 MB.",
    },
    contact: {
      eyebrow: "Contact", title: "Find us in Žilina", subtitle: "Call, write or visit us in person.",
      phone: "Phone", email: "Email", whatsapp: "WhatsApp", address: "Address", hours: "Opening hours",
      hoursNote: "By individual arrangement and the nature of the project.", directions: "Get directions", follow: "Follow us", mapTitle: "Map — Sedlo Services Žilina",
    },
    footer: {
      tagline: "Electronics repair, device repairs and electrotechnical solutions for households and businesses in Žilina and the surrounding area.",
      navTitle: "Navigation", contactTitle: "Contact", directions: "Get directions",
      rights: "All rights reserved.", privacy: "Privacy Policy", authorPre: "Website by ",
      links: [["Services", "#services"], ["Gallery", "#gallery"], ["Reviews", "#reviews"], ["About", "#about"], ["Contact", "#contact"], ["Book service", "#booking"]],
    },
    chatbot: {
      title: "Sedlo Services assistant", subtitle: "Creates a request for you",
      welcome: "Hello, please describe your problem or request.",
      placeholder: "Type a message…", needConsent: "Please confirm GDPR consent first",
      gdprPre: "I consent to the processing of my personal data for the purpose of handling my request and I have read the ",
      gdprLink: "privacy policy",
      unavailable: "Sorry, I'm currently unavailable. Please fill in the form or give us a call.",
    },
    cookie: { text: "We use cookies to improve the functionality of the site. More in the ", link: "privacy policy", accept: "Accept", decline: "Decline" },
    privacy: {
      back: "Back to site", eyebrow: "GDPR", title: "Privacy Policy",
      intro: "Protecting your personal data matters to Sedlo Services. This document explains what data we process, for what purpose and how long we keep it.",
      sections: [
        { h: "1. Controller", p: "The controller of personal data is Sedlo Services, {addr}. Contact for privacy matters: {email}, phone {phone}." },
        { h: "2. Purpose of processing", p: "Sedlo Services processes customers' personal data solely for the purpose of handling service requests, communicating with the customer and delivering the ordered services." },
        { h: "3. Scope of processed data", p: "The processed data may include name, phone number, e-mail address, description of the problem and any photographs submitted by the customer." },
        { h: "4. Sharing with third parties", p: "Personal data is not shared with third parties, except where required by law or necessary to fulfil the requested service." },
        { h: "5. Retention period", p: "Data is stored only for the period necessary to handle the request, but no longer than 24 months, unless applicable law requires a different retention period." },
        { h: "6. Rights of the data subject", p: "The customer has the right to access their personal data, to rectify, erase or restrict its processing, as well as the right to object to processing and the right to data portability. These rights can be exercised at {email}. The customer also has the right to lodge a complaint with the supervisory authority (Office for Personal Data Protection of the Slovak Republic)." },
        { h: "7. Consent and cookies", p: "Submitting a request via the form or chatbot is subject to granting consent to the processing of personal data. The website uses essential cookies for proper functioning; other cookies are used only with your consent." },
        { h: "8. Contact", p: "If you have any questions regarding the protection of personal data, contact us at {email}." },
      ],
    },
    meta: {
      title: "Sedlo Services — Electronics Repair Žilina | Fast solutions. Reliable service.",
      privacyTitle: "Privacy Policy — Sedlo Services",
      galleryTitle: "Gallery — Sedlo Services",
    },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const q = params.get("lang");
    if (q === "en" || q === "sk") return q;
    return localStorage.getItem("sedlo_lang") || "sk";
  });

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("sedlo_lang", l);
    const url = new URL(window.location.href);
    if (l === "sk") url.searchParams.delete("lang");
    else url.searchParams.set("lang", l);
    window.history.replaceState({}, "", url);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useI18n = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useI18n must be used within LanguageProvider");
  return ctx;
};
